export default response => {
  const errors = response.data.errors || []
  const invalid_fields = errors.map(error => {
    return error.source.param
  })

  return invalid_fields
}
